







































import { computed, defineComponent, ref } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import LandingCreatorsButton from "./LandingCreatorsButton.vue";

export default defineComponent({
  name: "LandingCreatorsFaq",
  components: { LandingCreatorsButton },
  setup() {
    const activeIndexes = ref<number[]>([]);

    const items = computed(() => [
      {
        key: "why",
        question: $t("Why should I join OléFans?"),
        answer: $t(
          "Because it’s more than a platform — it’s a place to stand out. OléFans is built around creativity, confidence, and individuality. Every creator is reviewed to keep the community exclusive, high-quality, and focused on standout talent."
        ),
      },
      {
        key: "commission",
        question: $t("What commission does OléFans take?"),
        answer: $t(
          `You keep 80% of everything you earn and retain full ownership of your content.{br}OléFans provides the tools, exposure, and infrastructure to help you monetize and grow.`
        ),
      },
      {
        key: "earn",
        question: $t("How much can I earn on OléFans?"),
        answer: $t(
          "There's no earning cap.{br}You keep 80% on all sales — and you can earn more through your referral link when new fans or creators join through you."
        ),
      },
      {
        key: "featured",
        question: $t("Do I have to pay to get featured on OléFans?"),
        answer: $t(
          "Not at all. By following our best practices, your profile can be featured in feeds, recommendations, and campaigns — helping you reach highly engaged fans worldwide."
        ),
      },
      {
        key: "promote",
        question: $t("Can I promote that I'm part of OléFans on social media?"),
        answer: $t(
          "Absolutely — we encourage it.{br}Sharing your profile helps convert your existing audience into subscribers and strengthens your personal brand."
        ),
      },
    ]);

    const toggle = (index: number) => {
      const i = activeIndexes.value.indexOf(index);
      if (i === -1) {
        activeIndexes.value.push(index);
      } else {
        activeIndexes.value.splice(i, 1);
      }
    };

    return {
      items,
      activeIndexes,
      toggle,
    };
  },
});
